<template>
  <div class="login-main">
    <div class="login-container">
      <el-row type="flex" justify="center">
        <div class="card-lf">
          <div class="top">
            <img src="../../assets/logo.png" alt="">
            <div class="title">
              <h1>娱乐场所治安管理系统</h1>
              <p>Entertainment Place</p>
            </div>
          </div>
          <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="input-div">
            <el-form-item prop="login_name">
              <el-input v-model="loginForm.login_name" placeholder="账号" @keyup.enter.native="login"></el-input>
            </el-form-item>
            <el-form-item prop="password" class="unlook">
              <el-input type="password" v-model="loginForm.password" placeholder="密码" show-password
                @keyup.enter.native="login"> </el-input>
            </el-form-item>
          </el-form>
          <div class="forget-password-div">
            <span class="forget-password" @click="forgetPassword">忘记密码</span>
          </div>
          <div class="login-div">
            <div>
              <el-button type="primary" @click="login" style="margin: 0;">登 录</el-button>
            </div>
            <div>
              <el-button @click="reg" style="border:0px;color: #6345D5;margin: 0;">注 册</el-button>
            </div>
          </div>
          <div class="qrcode" style="">
            <img style="width:110px;height: 110px;" src="../../assets/img/read.jpeg" alt="">
            <div class="right">
              <div class="qrTitle">扫描二维码登录小程序打卡</div>
              <div class="qrSubTitle">管理员联系方式：</div>
              <div class="qrPhone" style="">
                <div>{{ phone1 }}</div>
                <div>{{ phone2 }}</div>      
              </div>          
            </div>           
          </div>
          <!-- <div class="phone">
            <span>管理员联系方式：{{ phone1 }} <i></i> {{ phone2 }} </span>
          </div> -->
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      loginForm: {
        login_name: '',
        password: ''
      },
      phone1: '029-88413302',
      phone2: '029-88404282',
      loginFormRules: {
        login_name: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          // {
          //   max: 13,
          //   message: '手机号长度在不得超过13',
          //   trigger: 'blur'
          // }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ]
      },
      status: '',//  0/2：未审核；1：审核成功；3：审核失败
    }
  },

  methods: {
    changeActive() {
      this.$refs.downImg.style.display = 'block'
    },
    removeActive() {
      this.$refs.downImg.style.display = 'none'
    },
    async login() {
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) {
          return
        } else {
          const res = await this.$store.dispatch('user/login', this.loginForm)
          this.status = res.user.status
          if (this.status == 1) {// 0:未审核 2:审核中 1：审核成功；3：审核失败
            this.$router.push({
              path: '/enterprise_information'
            })
            this.$message.success('登录成功!')
            this.$store.commit('user/setActiveIndex', '/enterprise_information')
          } else if (this.status == 2) {
            this.$router.push({
              path: '/approval_ing'
            })
            this.$message.success('审核中!')
          } else if (this.status == 3 || this.status == 0) {
            this.$router.push({
              path: '/approval_no',
            })
          }
        }
      })
    },
    reg() {
      this.$router.push('/regist')
    },
    forgetPassword() {
      this.$router.push('/forget_password')
    },
    register() {
      this.$router.push('/register')
    }
  }
}
</script>

<style lang="less" scoped>
h2 {
  color: #d5effb;
  margin: 0;
  padding: 0;
}

h4 {
  color: #d3f0fe;
  padding: 10px;
  margin: 0;
}

.login-main {
  background: url(../../assets/img/login_bg.png) no-repeat;
  height: 100%;
  background-size: 100% 100%;
  width: 100%;
}

.login-main .down-app {
  width: 135px;
  top: 20px;
  right: 20px;
  position: absolute;
}

.login-main .down-app>span {
  padding: 10px;
  width: 100%;
  text-align: center;
  color: #b99871;
  font-size: 18px;
  cursor: pointer;
}

.login-main .down-app>img {
  width: 100%;
  height: 100%;
  display: none;
}

.login-container {
  width: 524px;
  height: 580px;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.card-lf {
  background-color: #fff;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  box-shadow: 0px 8px 20px 0px rgba(73, 46, 173, 0.2);

  .top {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 55px;
    margin-top: 40px;

    img {
      width: 55px;
      height: 55px;
    }

    .title {
      h1 {
        margin: 0;
        padding: 0 12px;
        width: 245px;
        font-size: 24px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #3D414F;
      }

      p {
        margin-top: 7px 0 0 8px;
        font-size: 16px;
        font-family: Arial;
        font-weight: bold;
        font-style: italic;
        color: #3D414F;
      }
    }
  }

  .unlook {
    position: relative;

    img {
      position: absolute;
      top: 17px;
      right: 13px;
    }
  }

  .phone {
    width: 100%;
    text-align: center;
    font-weight: 500;
    color: #6345D5;
    font-size: 14px;

    span {
      display: flex;
      justify-content: center;

      i {
        width: 14px;
      }
    }
  }
}

.card-lf p {
  color: #5a86d2;
  padding: 0px;
  font-size: 18px;
  margin: 10px;
  font-weight: 600;
}

.card-rl {
  border: none;
  text-align: center;
  height: 100%;
  position: relative;
  background-color: transparent;
}

.card-rl span {
  top: 45%;
  margin: auto;
  bottom: 0;
  right: 0;
  left: 0;
  position: absolute;
}

.el-row {
  height: 100%;
}

.input-div {
  margin: 40px 50px 0 50px;

  /deep/.el-input__inner {
    height: 50px;
    padding: 0 20px;
    font-size: 16px;
    border: 1px solid #C1C0D0;
    border-radius: 4px;
  }
}

.forget-password-div {
  height: 16px;
  position: relative;
  margin: 0 15px 30px 0;
}

.forget-password-div .forget-password {
  padding: 0px;
  margin: 0px 30px;
  position: absolute;
  top: 0;
  color: #747780;
  font-weight: 500;
  font-size: 16px;
  right: 0;
  text-align: right;
  cursor: pointer;
}

.login-div {
  height: 80px;
  margin: 10px 50px 20px 50px;
  font-weight: 500;

  .el-button--primary {
    background-color: #6345D5;
  }
}
.qrcode{
  display: flex; 
  align-items: center;
  padding-left:18%;
}
.right{
  margin-left:20px;
  color:#4B4D52;
  font-size: 16px;
  font-weight: 800;
}
.qrTitle{
  color: #6345D5;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 6px;
}
.qrPhone{
  font-weight: 500;
  margin-top: 6px;
}

.el-button {
  width: 100%;
  margin-top: 30px;
}

.register-div {
  position: relative;
}

.register-div .register {
  margin: 10px 20px;
  right: 0;
  text-align: right;
  color: #ccc;
  font-size: 12px;
  height: 100%;
}

.register-div .register span {
  color: #5a86d2;
  font-size: 12px;
  display: contents;
  margin-right: 20px;
  padding-right: 20px;
  cursor: pointer;
}
</style>
